//
import Model from "@/models/Model"

/**
 * This class describes a reject.
 *
 * @class      AReject (name)
 */
export default class AReject extends Model {

    /**
     * { function_description }
     *
     * @return     {string}  { description_of_the_return_value }
     */
    resource() {
        return 'reject'
    }
}